// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4287) return "static/chunks/4287.80507c6a08a85d50.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"780":"547df50defdba9a7","3896":"bb1fef47426ddd76","9520":"b45cf1e2378203c3","9669":"36d5d50ce72ac757"}[chunkId] + ".js";
};